import React from 'react';
import { useApp } from '../context/AppContext';

const DataLoadErrorBar = () => {
  const { loadError, refreshData, isLoading } = useApp();

  if (!loadError) return null;

  return (
    <div
      role="alert"
      style={{
        padding: '12px 16px',
        background: '#fef2f2',
        borderBottom: '1px solid #fecaca',
        color: '#991b1b',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '8px'
      }}
    >
      <span>{loadError}</span>
      <button
        type="button"
        onClick={() => refreshData && refreshData()}
        disabled={isLoading}
        style={{
          padding: '6px 14px',
          fontSize: '13px',
          fontWeight: 600,
          border: '1px solid #b91c1c',
          borderRadius: '8px',
          background: '#fff',
          color: '#991b1b',
          cursor: isLoading ? 'wait' : 'pointer'
        }}
      >
        {isLoading ? 'Retrying…' : 'Retry'}
      </button>
    </div>
  );
};

export default DataLoadErrorBar;
